var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-box"},[_c('mdb-doughnut-chart',{ref:"chartSalaryEmploye",staticClass:"chart",attrs:{"data":_vm.doughnutChartData,"options":_vm.doughnutChartOptions,"width":_vm.width,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }